import { useCanCollect } from '@Hooks/useCanCollect';
import { type ApiInvoice, EnumInvoiceType, isDirect } from '@Model';
import { isNullOrEmpty, renderCurrency } from '@synqo/frontend-component-library';

export function useCanCollectInvoice(apiInvoice: ApiInvoice) {
    const isCancellation = apiInvoice.type == EnumInvoiceType.Cancellation;
    const isCashInvoice = isDirect(apiInvoice.payment_terms.payment_method);
    const isPaid = !isNullOrEmpty(apiInvoice.payment_completed_at);
    const isCollectible = isCashInvoice && !isCancellation && !isPaid;
    const { isStateApproved, canCollect, canApprove } = useCanCollect(
        isCollectible,
        apiInvoice.total_gross_price,
        apiInvoice.process_state,
    );

    const collectionActionText = apiInvoice.type === EnumInvoiceType.CreditNote ? 'Jetzt auszahlen' : 'Jetzt kassieren';
    const collectionTooltip =
        isCollectible && apiInvoice.total_gross_price === 0
            ? `Der Betrag ${renderCurrency(0)} kann nicht ${apiInvoice.type === EnumInvoiceType.CreditNote ? 'ausgezahlt' : 'kassiert'} werden.`
            : undefined;

    return {
        isCashInvoice,
        isStateApproved,
        isCancellation,
        canCollect,
        canApprove,
        collectionActionText,
        collectionTooltip,
    };
}
